import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { applicationInsight } from "../../appInsight/telemetry";
import {
  logIn,
  forgotPassword,
  clearError,
} from "../../ducks/authentication/index";
import { resetVerify } from "../../ducks/proposals/index";
import Card from "../atoms/card/Card";
import Button from "../atoms/button/Button";
import ROUTES from "../../constants/routes";
import Modal, { MODAL_CONTENT } from "../organisms/modals/baseModal/Modal";
import LoginForm from "../organisms/forms/Login";
import ForgotPassword from "../organisms/forms/ForgotPassword";
import SignupLoginCopy from "../helpers/SignupLoginCopy";
import { withRouter } from "react-router-dom";

const Login = ({
  logIn,
  forgotPassword,
  clearError,
  isAuthenticated,
  isFetching,
  error,
  needPasswordChange,
  isButtonDisable,
  type,
  targetLocationData,
  verifyData,
  resetVerify,
  history: { location, push, replace },
}) => {
  const payload = location.search?.split("payload=")?.[1];

  useEffect(() => {
    applicationInsight.initialize();
  }, []);

  useEffect(() => {
    if (payload && isAuthenticated && targetLocationData)
      return replace(targetLocationData?.location);
    if (isAuthenticated) return push(ROUTES.dashboard.route);
    if (needPasswordChange) return push(ROUTES.pwChange.route);
  }, [isAuthenticated, targetLocationData, needPasswordChange]);

  // if (isAuthenticated) return <Redirect to={ROUTES.dashboard.route} />;
  // if (needPasswordChange) return <Redirect to={ROUTES.pwChange.route} />;

  return (
    <div>
      <section>
        <Card white noPaddingDesktop>
          <SignupLoginCopy />
        </Card>
      </section>
      <section>
        <Row>
          <Col>
            <Card>
              <LoginForm
                type={type}
                error={error}
                actions={{ logIn, clearError }}
                isButtonDisable={isButtonDisable}
                verifyData={verifyData}
                resetVerify={resetVerify}
              />
              <Row>
                <Col>
                  <Modal
                    sayTitle={`Forgot Password`}
                    triggerEl={Button}
                    triggerProps={{
                      id: "log-in-page-forgot-password-btn",
                      link: true,
                      children: "Forgot password?",
                      onClick: () => {
                        clearError();
                      },
                    }}
                    render={({ toggle }) => {
                      return (
                        <>
                          {MODAL_CONTENT.forgotPassword}
                          <ForgotPassword
                            type={type}
                            error={error}
                            actions={{ forgotPassword }}
                            toggleModal={toggle}
                            isFetching={isFetching}
                          />
                        </>
                      );
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </section>
    </div>
  );
};

const mapStateToProps = ({
  authentication: {
    isAuthenticated,
    error,
    type,
    isFetching,
    needPasswordChange,
    isButtonDisable,
    targetLocationData,
  },
  proposals: { verifyData },
}) => ({
  isAuthenticated,
  error,
  type,
  isFetching,
  needPasswordChange,
  isButtonDisable,
  targetLocationData,
  verifyData,
});

const mapDispatchToProps = { logIn, forgotPassword, clearError, resetVerify };

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withAITracking(applicationInsight.reactPlugin, Login))
);
